var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "base-button",
    {
      attrs: { transparent: "", size: "sm" },
      on: { click: _vm.$helpers.openSupportChat }
    },
    [
      _vm.hasDefaultSlot
        ? _vm._t("default")
        : _c("div", [
            _vm._v(
              "\n    " +
                _vm._s(_vm.$t("contact-by-chat-tech-problems")) +
                "\n  "
            )
          ])
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-71592f0a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-71592f0a","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/utils/SupportChatButton.vue
// module id = 3456
// module chunks = 28